import React from 'react';
import { useCounterOfferStore } from '@/stores/counterOfferStore';
import { formatCurrency } from '@/utils/misc';
import { computeLoanDetails } from '@/utils/poolCalculations';

export const ComparisonCalculator: React.FC = () => {
  const poolAmount = useCounterOfferStore((state) => state.poolAmount);
  const poolRate = useCounterOfferStore((state) => state.poolRate);
  const poolTermMonths = useCounterOfferStore((state) => state.poolTermMonths);
  const poolLoanType = useCounterOfferStore((state) => state.poolLoanType);
  const counterAmount = useCounterOfferStore((state) => state.counterAmount);
  const counterRate = useCounterOfferStore((state) => state.counterRate);
  const counterTermMonths = useCounterOfferStore((state) => state.counterTermMonths);
  // Pool calculations

  const poolLoanDetails = computeLoanDetails(
    parseFloat(poolAmount),
    parseFloat(poolRate),
    poolLoanType,
    parseInt(poolTermMonths)
  );
  const poolMonthlyPayment = poolLoanDetails.monthlyPayment;
  const poolFinalRepayment = poolLoanDetails.overallRepay;

  const counterLoanDetails = computeLoanDetails(
    parseFloat(counterAmount),
    parseFloat(counterRate),
    poolLoanType,
    counterTermMonths
  );
  const counterMonthlyPayment = counterLoanDetails.monthlyPayment;
  const counterFinalRepayment = counterLoanDetails.overallRepay;

  return (
    <div className="w-full p-4 bg-[#F4F4F4] rounded-[10px] flex flex-col justify-center items-start gap-2">
      <div className="w-full inline-flex items-center gap-1">
        <div className="w-3.5 h-3.5 relative overflow-hidden flex items-center justify-center">
          <img src="/mdi-calculator.svg" alt="Calculator" className="w-3.5 h-3.5" />
        </div>
        <div
          className="text-black text-sm font-medium break-words"
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          Calculator
        </div>
      </div>

      {/* Pool vs Counter Offer Comparison */}
      <div className="w-full grid grid-cols-2 gap-2">
        {/* Pool Estimated Monthly Payment */}
        <div className="flex-1 px-3 py-2 bg-[#EAEBE5] rounded-[10px] flex flex-col items-start gap-1.5">
          <div className="w-full inline-flex items-center justify-between">
            <div
              className="flex-1 opacity-70 text-black text-xs font-normal leading-[1.67] break-words"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              Pool Estimated Monthly Payment
            </div>
            <div className="w-4 h-4 relative overflow-hidden flex items-center justify-center">
              <img src="/cons.svg" alt="Info" className="w-4 h-4" />
            </div>
          </div>
          <div
            className="w-full text-black text-sm font-extrabold break-words"
            style={{
              fontFamily: 'var(--ep-font-avenir)',
            }}
          >
            {formatCurrency(poolMonthlyPayment.toFixed(2))}
          </div>
        </div>

        {/* Counter Offer Monthly Interest */}
        <div className="flex-1 px-3 py-2 bg-[#EAEBE5] rounded-[10px] flex flex-col items-start gap-1.5">
          <div className="w-full inline-flex items-center justify-between">
            <div
              className="flex-1 opacity-70 text-black text-xs font-normal leading-[1.67] break-words"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              Counter Offer Estimated Monthly Payment
            </div>
            <div className="w-4 h-4 relative overflow-hidden flex items-center justify-center">
              <img src="/cons.svg" alt="Info" className="w-4 h-4" />
            </div>
          </div>
          <div
            className="w-full text-black text-sm font-extrabold break-words"
            style={{
              fontFamily: 'var(--ep-font-avenir)',
            }}
          >
            {counterAmount && counterRate ? formatCurrency(counterMonthlyPayment.toFixed(2)) : '--'}
          </div>
        </div>

        {/* Pool Estimated Final Repayment */}
        <div className="flex-1 px-3 py-2 bg-[#EBE6E5] rounded-[10px] flex flex-col items-start gap-1.5">
          <div className="w-full inline-flex items-center justify-between">
            <div
              className="flex-1 opacity-70 text-black text-xs font-normal leading-[1.67] break-words"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              Pool Estimated Final Repayment
            </div>
            <div className="w-4 h-4 relative overflow-hidden flex items-center justify-center">
              <img src="/cons.svg" alt="Info" className="w-4 h-4" />
            </div>
          </div>
          <div
            className="w-full text-black text-sm font-extrabold break-words"
            style={{
              fontFamily: 'var(--ep-font-avenir)',
            }}
          >
            {formatCurrency(poolFinalRepayment.toFixed(2))}
          </div>
        </div>

        {/* Counter Offer Final Repayment */}
        <div className="flex-1 px-3 py-2 bg-[#EBE6E5] rounded-[10px] flex flex-col items-start gap-1.5">
          <div className="w-full inline-flex items-center justify-between">
            <div
              className="flex-1 opacity-70 text-black text-xs font-normal leading-[1.67] break-words"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              Counter Offer Estimated Final Repayment
            </div>
            <div className="w-4 h-4 relative overflow-hidden flex items-center justify-center">
              <img src="/cons.svg" alt="Info" className="w-4 h-4" />
            </div>
          </div>
          <div
            className="w-full text-black text-sm font-extrabold break-words"
            style={{
              fontFamily: 'var(--ep-font-avenir)',
            }}
          >
            {counterAmount && counterRate ? formatCurrency(counterFinalRepayment.toFixed(2)) : '--'}
          </div>
        </div>
      </div>
    </div>
  );
};
